import { render, staticRenderFns } from "./AlertaConfigForm.vue?vue&type=template&id=7b9279d4&scoped=true&"
import script from "./AlertaConfigForm.vue?vue&type=script&lang=ts&"
export * from "./AlertaConfigForm.vue?vue&type=script&lang=ts&"
import style0 from "./AlertaConfigForm.vue?vue&type=style&index=0&id=7b9279d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b9279d4",
  null
  
)

export default component.exports